import { useState} from "react";
import { useGetReporteCBOIndex, useGetTotalMensualSucursal } from "../../Services/ReporteCBO";
import {
  Box,
  Paper,
  Typography,
  CircularProgress,
  Tabs,
  Tab,
  Grid,
   Card,
    CardContent,
    TextField,
  MenuItem,
} from "@mui/material";

import { GiMoneyStack } from "react-icons/gi";
import { useGetRMEMensualReporte } from "../../Services/RMEIndex";
import { MdOutlineMedicalServices } from "react-icons/md";
import { MdInfoOutline } from "react-icons/md";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";

import { FaHospitalAlt } from "react-icons/fa";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer,
  Legend,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Line,
  LineChart
} from "recharts";
import dayjs from "dayjs";
import "dayjs/locale/es";
import weekOfYear from "dayjs/plugin/weekOfYear";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import Logocolor from "../../Image/Logo.png";
import { formatCLP } from "../FuncionesGenerales/FormatoCLP";
import { TituloPrincipal, Input, SubTitulo } from "../../Layouts/CustomStyles";
import weekYear from "dayjs/plugin/weekYear";

dayjs.extend(weekOfYear);
dayjs.extend(weekYear);
dayjs.locale("es");


const CardResumenMensual = ({
  titulo,
  periodo,
  monto,
  Icono,
  colorIcono = "#5cd09aff",
}) => (
  <Card
    sx={{
      backgroundColor: "#ffffff",
      borderRadius: 3,
      boxShadow: "0px 4px 10px rgba(42, 103, 69, 0.4)",
      transition: "transform 0.2s, box-shadow 0.2s",
      "&:hover": {
        transform: "translateY(-3px)",
        boxShadow: "0px 6px 14px rgba(42, 103, 69, 0.5)",
      },
    }}
  >
    <CardContent
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          width: "80%",
          display: "flex",
          flexDirection: "column",
          gap: 1,
        }}
      >
        <Typography
          variant="h6"
          fontWeight={400}
          sx={{ fontFamily: "Poppins", color: "#585857" }}
        >
          {titulo}
        </Typography>

        <Typography
          variant="body2"
          sx={{ fontFamily: "Poppins", color: "#8a8a8a" }}
        >
          {periodo.nombre_mes} {periodo.anio}
        </Typography>

        <Typography
          variant="h6"
          fontWeight={500}
          sx={{ fontFamily: "Poppins", color: "#585857" }}
        >
          Total{" "}
          <Box component="span" sx={{ color: "#2a8d74", fontWeight: 600 }}>
            {formatCLP(monto)}
          </Box>
        </Typography>
      </Box>

      <Box>
        <Icono size={58} color={colorIcono} />
      </Box>
    </CardContent>
  </Card>
);



export const CBODashboard = () => {
  const hoy = dayjs();
  const [filtroRme, setFiltroRme] = useState({
    anio: dayjs().year(),
    mes: dayjs().month() + 1,
  });
  
  const {
    resumenMensual,
  } = useGetRMEMensualReporte(filtroRme);

  const PeriodoMensualRME = resumenMensual?.periodo || {};
  const totales = resumenMensual?.totales || {};
  const MESES = [
    "enero",
    "febrero",
    "marzo",
    "abril",
    "mayo",
    "junio",
    "julio",
    "agosto",
    "septiembre",
    "octubre",
    "noviembre",
    "diciembre",
  ];

const [fechaSeleccionada, setFechaSeleccionada] = useState(dayjs());

const [filtros, setFiltros] = useState({
  anio: hoy.weekYear(),   // ✅ AÑO ISO
  semana: hoy.week(),     // ✅ SEMANA ISO
});



  const [tabIndex, setTabIndex] = useState(0);


const [filtrosMensual, setFiltrosMensual] = useState({
  anio: dayjs().year(),
  mes: dayjs().month() + 1, // 👈 month es 0-11
});

const { ReporteCBOIndex, loading } = useGetReporteCBOIndex(filtros);

const { totalesMensuales } =
  useGetTotalMensualSucursal(filtrosMensual);
 
const MontoTotalMensual =
  totalesMensuales?.generalmensual?.[0] ?? {};

const PeriodoMensual = totalesMensuales?.periodo || {};
const deudoresTotalesMensual = MontoTotalMensual?.deudores_por_prevision || [];



const dataDeudoresTotaltesMensual =
  deudoresTotalesMensual.map(item => ({
    name: item.prevision,
    value: Number(item.cantidad_deudores),
  })) || [];

const hayDeudores =
  dataDeudoresTotaltesMensual.length > 0 &&
  dataDeudoresTotaltesMensual.some(item => item.value > 0);

const detallePacientes = Object.entries(
  MontoTotalMensual?.pacientes || {}
)
  .filter(([key, value]) =>
    value?.cantidad > 0 && value?.monto > 0 && key !== 'total'
  )
  .map(([key, value]) => ({
    tipo: key.replace('_', ' '),
    cantidad: value.cantidad,
    monto: Number(value.monto),
  }));
// Pagos
const pagos = MontoTotalMensual?.pagos ?? null;

// 👉 Hay información SOLO si hay pacientes > 0
const hayInfoPagos =
  pagos &&
  Number(pagos.total_pacientes_atendidos) > 0;

// Valores (solo si hay info)
const totalPacientes = hayInfoPagos
  ? pagos.total_pacientes_atendidos
  : null;

const porcentajePagados = hayInfoPagos
  ? pagos.porcentaje_pagado
  : null;

const porcentajePendientes = hayInfoPagos
  ? pagos.porcentaje_pendiente
  : null;


const chartDataPrevisionesmensual =
  MontoTotalMensual?.previsiones?.map(item => ({
    name: item.prevision,
    monto: Number(item.total_monto),
    pacientes: item.total_pacientes,
  })) || [];

  const hayPrevisiones =
  chartDataPrevisionesmensual.length > 0 &&
  chartDataPrevisionesmensual.some(item => item.monto > 0);







const detalleingresoyreingreso = MontoTotalMensual?.estado_ingreso_reingreso;


const chartPagosIngresoReingreso = detalleingresoyreingreso
  ? [
      {
        tipo: "Ingreso",
        pagados: Number(detalleingresoyreingreso.ingreso?.pagados?.cantidad || 0),
        pendientes: Number(detalleingresoyreingreso.ingreso?.no_pagados?.cantidad || 0),
      },
      {
        tipo: "Reingreso",
        pagados: Number(detalleingresoyreingreso.reingreso?.pagados?.cantidad || 0),
        pendientes: Number(detalleingresoyreingreso.reingreso?.no_pagados?.cantidad || 0),
      },
    ]
  : [];

  

/* mensual sucursal */
const MontoTotalMensualSucursal =
  totalesMensuales?.sucursalmensual ?? [];



const obtenerDetallePacientes = (pacientes) => {
  return Object.entries(pacientes || {})
    .filter(
      ([key, value]) =>
        key !== "total" &&
        Number(value?.cantidad) > 0 &&
        Number(value?.monto) > 0
    )
    .map(([key, value]) => ({
      tipo: key, // ingreso | reingreso | terapia
      cantidad: Number(value.cantidad),
      monto: Number(value.monto),
    }));
};



  const hasDataPagosIngresoReingreso =
  chartPagosIngresoReingreso.length > 0 &&
  chartPagosIngresoReingreso.some(
    (item) => item.pagados > 0 || item.pendientes > 0
  );


 












  /* semanal */
const periodo = ReporteCBOIndex?.periodo;

const inicioFormateado = periodo?.inicio_semana
  ? dayjs(periodo.inicio_semana).format("DD [de] MMMM [de] YYYY")
  : "";

const finFormateado = periodo?.fin_semana
  ? dayjs(periodo.fin_semana).format("DD [de] MMMM [de] YYYY")
  : "";


  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "300px",
          gap: 2,
          position: "relative",
        }}
      >
        <CircularProgress size={90} thickness={4} sx={{ color: "#6fd385ff" }} />
        <Box
          component="img"
          src={Logocolor}
          alt="Logo"
          sx={{ width: "55px", height: "55px", position: "absolute", top: "90px" }}
        />
        <Typography sx={{ fontFamily: "Poppins", fontSize: "18px", mt: 2 }}>
          Cargando reporte...
        </Typography>
      </Box>
    );
  }


  const sucursales = ReporteCBOIndex?.sucursales || [];

  // 👇 sucursal seleccionada por tab
  const sucursalActual = sucursales[tabIndex] || {};

  // 👇 pacientes vienen desde la sucursal
  const pacientes = sucursalActual.pacientes || {};

  const detalle = sucursalActual?.detalle_ingreso_reingreso || {};
  
const detalleDeudoresSemanal = sucursalActual?.deudores?.semanal || [];

const dataDeudoresSemanal = detalleDeudoresSemanal.map(item => ({
  name: item.prevision,
  value: Number(item.cantidad_deudores) || 0,
}));




const chartDataEstadoPagoIngresoReingreso = [
  {
    estado: "Pagados",
    ingreso: Number(detalle.ingreso?.pagados || 0),
    reingreso: Number(detalle.reingreso?.pagados || 0),
  },
  {
    estado: "no pagados",
    ingreso: Number(detalle.ingreso?.pendientes || 0),
    reingreso: Number(detalle.reingreso?.pendientes || 0),
  },
];


const chartData = [
  {
    name: "Ingreso",
    value: Number(pacientes.ingreso?.monto || 0),
  },
  {
    name: "Reingreso",
    value: Number(pacientes.reingreso?.monto || 0),
  },
  {
    name: "En terapia",
    value: Number(pacientes.en_terapia?.monto || 0),
  },
  {
    name: "Posturografo",
    value: Number(pacientes.posturografo?.monto || 0),
  },
].filter(item => item.value > 0);

const renderMontoLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  value,
  name,
}) => {
  const RADIAN = Math.PI / 180;
  const radius = innerRadius + (outerRadius - innerRadius) * 1.3;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="#333"
      textAnchor="middle"
      dominantBaseline="central"
      style={{ fontSize: "12px", fontFamily: "Poppins", fontWeight: 500 }}
    >
      {`${name}`}
      <tspan x={x} dy="1.2em" fontSize="11">
        {Number(value).toLocaleString("es-CL", {
          style: "currency",
          currency: "CLP",
          maximumFractionDigits: 0,
        })}
      </tspan>
    </text>
  );
};

const detalleporcentualingresoreingreso = sucursalActual?.detalle_ingreso_reingreso || {};


const pagados =
  Number(detalleporcentualingresoreingreso.ingreso?.pagados || 0) +
  Number(detalleporcentualingresoreingreso.reingreso?.pagados || 0);

const noPagados =
  Number(detalleporcentualingresoreingreso.ingreso?.pendientes || 0) +
  Number(detalleporcentualingresoreingreso.reingreso?.pendientes || 0);

const total = pagados + noPagados;

const chartDataporcentualingresoreingreso = [
  {
    name: "Pagados",
    value: pagados,
    porcentaje: total ? ((pagados / total) * 100).toFixed(1) : 0,
  },
  {
    name: "no pagados",
    value: noPagados,
    porcentaje: total ? ((noPagados / total) * 100).toFixed(1) : 0,
  },
];


const renderLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, value, porcentaje }) => {
  const RADIAN = Math.PI / 180;
  const radius = innerRadius + (outerRadius - innerRadius) / 0.6;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="#252525ff"
      textAnchor="middle"
      dominantBaseline="central"
      style={{ fontSize: '1rem', fontFamily: "Poppins", fontWeight: 500 }}
    >
      {`${porcentaje}% (${value})`}
    </text>
  );
};


const sesionesIngresoReingreso =
  sucursalActual?.sesiones?.ingreso_reingreso?.detalle || [];
  

const chartDatasesionesingresosreingreso = sesionesIngresoReingreso
  .filter(item => Number(item.n_sesiones) > 0) 
  .map(item => ({
    sesiones: `${item.n_sesiones.toString().padStart(2, "0")} ${
      item.n_sesiones === 1 ? "SESIÓN" : "SESIONES"
    }`,
    cantidad: Number(item.cantidad_pacientes),
    orden: item.n_sesiones,
  }))
  .sort((a, b) => a.orden - b.orden);



  
const sesionesEnterapia =
  sucursalActual?.sesiones?.terapia?.detalle || [];
  

const chartDatasesionesTerapia = sesionesEnterapia
  .filter(item => Number(item.n_sesiones) > 0) // 👈 elimina los 0
  .map(item => ({
    sesiones: `${item.n_sesiones.toString().padStart(2, "0")} ${
      item.n_sesiones === 1 ? "SESIÓN" : "SESIONES"
    }`,
    cantidad: Number(item.cantidad_pacientes),
    orden: item.n_sesiones,
  }))
  .sort((a, b) => a.orden - b.orden);





  const normalizarKineKey = (kine) => {
  if (!kine) return "";

  const limpio = kine
    .toUpperCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim();

  
  if (/^[A-Z]{1,2}[A-Z]+$/.test(limpio)) {
    return limpio;
  }

 
  const partes = limpio.split(" ");
  if (partes.length >= 2) {
    const inicial = partes[0][0];
    const apellido = partes[1];
    return `${inicial}${apellido}`;
  }

  return limpio;
};

const kinesRaw = sucursalActual?.kines?.detalle || [];

const kinesAgrupados = Object.values(
  kinesRaw.reduce((acc, item) => {
    const key = normalizarKineKey(item.kine);

    if (!acc[key]) {
      acc[key] = {
        kine_key: key,
        kine: item.kine, // se puede ajustar luego
        total_pacientes: 0,
        pacientes_por_estado: {
          ingreso: 0,
          reingreso: 0,
          en_terapia: 0,
          pendiente: 0,
        },
      };
    }

    acc[key].total_pacientes += Number(item.total_pacientes || 0);

    acc[key].pacientes_por_estado.ingreso += Number(
      item.pacientes_por_estado?.ingreso || 0
    );
    acc[key].pacientes_por_estado.reingreso += Number(
      item.pacientes_por_estado?.reingreso || 0
    );
    acc[key].pacientes_por_estado.en_terapia += Number(
      item.pacientes_por_estado?.en_terapia || 0
    );
    acc[key].pacientes_por_estado.pendiente += Number(
      item.pacientes_por_estado?.pendiente || 0
    );

    return acc;
  }, {})
);

const chartDataKines = kinesAgrupados
  .map(k => ({
    name: k.kine,
    total: k.total_pacientes,
    ingreso:k.pacientes_por_estado.ingreso,
    reingreso:k.pacientes_por_estado.reingreso,
    terapia:k.pacientes_por_estado.en_terapia,
    pendiente:k.pacientes_por_estado.pendiente


  }))
  .sort((a, b) => b.total - a.total);


  const chartDataPrevisiones = (sucursalActual?.previsiones || [])
  .map(p => ({
    name: p.prevision,
    monto: Number(p.total_monto),
    pacientes: Number(p.total_pacientes),
  }))
  .sort((a, b) => b.monto - a.monto);

  const chartDataNoPagados = Object.values(
  (sucursalActual?.no_pagados_por_prevision_y_estado || []).reduce((acc, item) => {
    const prevision = item.prevision;
    const estado = item.estado_paciente.toLowerCase(); // ingreso | reingreso | terapia | pendiente
    const cantidad = Number(item.cantidad_pacientes || 0);

    if (!acc[prevision]) {
      acc[prevision] = {
        name: prevision,
        ingreso: 0,
        reingreso: 0,
        terapia: 0,
        pendiente: 0,
        total: 0,
      };
    }

    // Mapear estados
    if (estado.includes('ingreso')) acc[prevision].ingreso += cantidad;
    else if (estado.includes('reingreso')) acc[prevision].reingreso += cantidad;
    else if (estado.includes('terapia')) acc[prevision].terapia += cantidad;
    else if (estado.includes('pendiente')) acc[prevision].pendiente += cantidad;

    acc[prevision].total += cantidad;

    return acc;
  }, {})
).sort((a, b) => b.total - a.total);


const COLORS = [
  "#6fd385",
  "#3cb294",
  "#f4b860",
  "#f28b82",
  "#9fa8da",
  "#80cbc4",
];


/* cargas semanal */
const hasData =
  Array.isArray(chartData) &&
  chartData.some((item) => Number(item.value) > 0);


  const hasDataEstadoPago =
  Array.isArray(chartDataEstadoPagoIngresoReingreso) &&
  chartDataEstadoPagoIngresoReingreso.some(
    (item) =>
      Number(item.ingreso || 0) > 0 ||
      Number(item.reingreso || 0) > 0
  );

  const hasDataPagosingresoReingresosSemanal =
  Array.isArray(chartDataporcentualingresoreingreso) &&
  chartDataporcentualingresoreingreso.some(item => item.value > 0);

    const hasDataPrevisiones =
  Array.isArray(chartDataPrevisiones) &&
  chartDataPrevisiones.some(item => Number(item.monto) > 0);

const hasDataKines =
  Array.isArray(chartDataKines) &&
  chartDataKines.some(item =>
    (item.ingreso || 0) +
    (item.reingreso || 0) +
    (item.terapia || 0) +
    (item.pendiente || 0) > 0
  );

  const hasDataSesiones =
  Array.isArray(chartDatasesionesingresosreingreso) &&
  chartDatasesionesingresosreingreso.some(
    item => Number(item.cantidad || 0) > 0
  );

  const hasDataSesionesTerapia =
  Array.isArray(chartDatasesionesTerapia) &&
  chartDatasesionesTerapia.some(
    item => Number(item.cantidad || 0) > 0
  );

  const hasDataNoPagados =
  Array.isArray(chartDataNoPagados) &&
  chartDataNoPagados.some(item =>
    Number(item.ingreso || 0) +
    Number(item.reingreso || 0) +
    Number(item.terapia || 0) +
    Number(item.pendiente || 0) > 0
  );

const hasDataDeudoresSemanal =
  Array.isArray(dataDeudoresSemanal) &&
  dataDeudoresSemanal.some(item => Number(item.value || 0) > 0);

  return (
    <>
    <Box>
     <Box
  sx={{
    justifyContent:'flex-end',
    display: "flex",
    gap: 2,
    mb: 3,
    alignItems: "center",
  }}
>
  {/* Año */}
  <TextField
    select
    label="Año"
    value={filtroRme.anio}
    onChange={(e) =>
      setFiltroRme((prev) => ({
        ...prev,
        anio: Number(e.target.value),
      }))
    }
    size="small"
    sx={Input }
  >
    {[ 2025, 2026, 2027, 2028].map((anio) => (
      <MenuItem key={anio} value={anio}>
        {anio}
      </MenuItem>
    ))}
  </TextField>

  {/* Mes */}
<TextField
  select
  label="Mes"
  value={filtroRme.mes}
  onChange={(e) =>
    setFiltroRme((prev) => ({
      ...prev,
      mes: Number(e.target.value),
    }))
  }
  size="small"
  sx={Input}
>
  {MESES.map((nombreMes, index) => (
    <MenuItem key={index + 1} value={index + 1}>
      {nombreMes}
    </MenuItem>
  ))}
</TextField>
</Box>
<Box mb={3}>
     <Typography variant="h6" sx={{...TituloPrincipal, mt:2}}>
  Período  {PeriodoMensualRME.nombre_mes} {PeriodoMensualRME.anio}
</Typography>
</Box>
<Grid container spacing={2}>
 
  {/* INGRESO PACIENTES */}
  <Grid size={{xs:12, sm:6}}>
    <CardResumenMensual
      titulo="Ingreso Pacientes"
      periodo={PeriodoMensual}
      monto={totales.ingreso_paciente}
      Icono={MdOutlineMedicalServices}
      colorIcono="#42a5f5"
    />
  </Grid>

  {/* SAP (Clínica interna) */}
  <Grid size={{xs:12, sm:6}}>
    <CardResumenMensual
      titulo="Clínica Interna (SAP)"
      periodo={PeriodoMensual}
      monto={totales.sap}
      Icono={FaHospitalAlt}
      colorIcono="#ab47bc"
    />
  </Grid>
</Grid>


</Box>
    <Box sx={{ display:"flex", gap: 2, mb: 3,  mt:4, justifyContent:'flex-end'  }}>
       <TextField
    select
    label="Año"
    size="small"
    value={filtrosMensual.anio}
    sx={Input}
    onChange={(e) =>
      setFiltrosMensual(prev => ({
        ...prev,
        anio: Number(e.target.value),
      }))
    }
  >
    {[2025, 2026, 2027, 2028].map((anio) => (
      <MenuItem key={anio} value={anio}>
        {anio}
      </MenuItem>
    ))}
  </TextField>
  {/* MES */}
  <TextField
    select
    label="Mes"
    size="small"
    value={filtrosMensual.mes}
    sx={Input}
    onChange={(e) =>
      setFiltrosMensual(prev => ({
        ...prev,
        mes: Number(e.target.value),
      }))
    }
  >
    {Array.from({ length: 12 }, (_, i) => (
      <MenuItem key={i + 1} value={i + 1}>
        {dayjs().month(i).locale("es").format("MMMM")}
      </MenuItem>
    ))}
  </TextField>
 
</Box>
    <Box sx={{ mt: 3, mb: 5 }}>
       <Typography variant="h6" sx={{...TituloPrincipal, mt:2, display:'flex', alignItems:'center', justifyContent:'center' }}>
  Período Mensual {PeriodoMensual.nombre_mes} {PeriodoMensual.anio}
</Typography>


       <Box mt={5} mb={5}>
        <Grid container spacing={2}>
            <Grid size={12} mt={2} mb={2}>
               <Typography variant="h6" sx={{...TituloPrincipal, mt:2, mb:2}}>
  Totales mensuales {PeriodoMensual.nombre_mes} {PeriodoMensual.anio}
</Typography>
            <Grid container spacing={2} >
          <Grid size={{xs:12, sm:6, md:4}}>
               <Box sx={{ width: "100%", }}>
             <Card
                                    sx={{
                                       
                                        backgroundColor: "#ffffff",
                                        borderRadius: 3,
                                        boxShadow: "0px 4px 10px rgba(42, 103, 69, 0.4)",
                                        transition: "transform 0.2s, box-shadow 0.2s",
                                    }}
                                >
                                    <CardContent
                                        sx={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                width: "80%",
                                                display: "flex",
                                                flexDirection: "column",
                                                justifyContent: "center",
                                                alignItems: "flex-start",
                                                gap: 1,
                                                  mb:1
                                            }}
                                        >
                                            <Typography
                                                variant="h5"
                                                fontWeight={400}
                                                sx={{ fontFamily: "Poppins", color: "#585857" }}
                                            >

                                              {PeriodoMensual.nombre_mes} {PeriodoMensual.anio}
                                            </Typography>
            
                                            <Typography
                                                variant="h6"
                                                fontWeight={500}
                                                sx={{ fontFamily: "Poppins", color: "#585857" }}
                                            >
                                                Total{" "}
                                                <Box component="span" sx={{ color: "#2a8d74", fontWeight: 500 }}>
                                                    
                                                  {MontoTotalMensual?.ingreso_paciente_monto
  ? `Monto Mes ${formatCLP(MontoTotalMensual.ingreso_paciente_monto)}`
  : " Sin información"}

                                                        
                                                </Box>
                                            </Typography>
                                        </Box>
            
                                        <Box>
                                            <GiMoneyStack size={60} color="#5cd09aff" />
                                        </Box>
                                    </CardContent>
                                </Card>
                                
                                </Box>
          </Grid>
          
            {MontoTotalMensualSucursal?.map((sucursal, index) => {
  
  return (
  

          <Grid size={{xs:12, sm:6, md:4}}>
        
               <Box sx={{ width: "100%", }}>
             <Card
                                    sx={{
                                       
                                        backgroundColor: "#ffffff",
                                        borderRadius: 3,
                                        boxShadow: "0px 4px 10px rgba(42, 103, 69, 0.4)",
                                        transition: "transform 0.2s, box-shadow 0.2s",
                                    }}
                                >
                                    <CardContent
                                        sx={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                width: "100%",
                                                display: "flex",
                                                flexDirection: "column",
                                                justifyContent: "center",
                                                alignItems: "flex-start",
                                                gap: 1,
                                                  mb:1
                                            }}
                                        >
                                            <Typography
                                                variant="h5"
                                                fontWeight={400}
                                                sx={{ fontFamily: "Poppins", color: "#585857" }}
                                            >

                                              {sucursal.sucursal} {PeriodoMensual.nombre_mes} {PeriodoMensual.anio}
                                            </Typography>
            
                                            <Typography
                                                variant="h6"
                                                fontWeight={500}
                                                sx={{ fontFamily: "Poppins", color: "#585857" }}
                                            >
                                                Total{" "}
                                                <Box component="span" sx={{ color: "#2a8d74", fontWeight: 500 }}>
                                                    
                                                   Monto Mes {formatCLP(sucursal.monto_mensual)}
                                                        
                                                </Box>
                                            </Typography>
                                        </Box>
            
                                        <Box>
                                            <GiMoneyStack size={60} color="#5cd09aff" />
                                        </Box>
                                    </CardContent>
                                </Card>
                                
                                </Box>
          </Grid>
            )})}
            
            
            </Grid>
            </Grid>

             {/*  <Grid size={12} mt={2} mb={2}>
               <Typography variant="h6" sx={{...TituloPrincipal, mt:2, mb:2}}>
  Detalle Sesiones {PeriodoMensual.nombre_mes} {PeriodoMensual.anio}
</Typography>
            <Grid container spacing={2} >
           <Grid size={{xs:12, sm:6, md:4}} >
               <Box sx={{ width: "100%", }}>
            <Card
                                    sx={{
                                        
                                        backgroundColor: "#ffffff",
                                        borderRadius: 3,
                                        boxShadow: "0px 4px 10px rgba(42, 103, 69, 0.4)",
                                        transition: "transform 0.2s, box-shadow 0.2s",
                                    }}
                                >
                                    <CardContent
                                        sx={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                width: "100%",
                                                display: "flex",
                                                flexDirection: "column",
                                                justifyContent: "center",
                                                alignItems: "flex-start",
                                                gap: 1,
                                                mb:1
                                            }}
                                        >
                                            <Typography
                                                variant="h5"
                                                fontWeight={400}
                                                sx={{ fontFamily: "Poppins", color: "#585857" }}
                                            >

                                             Sesiones pagadas Global
                                            </Typography>
            
                                            <Typography
                                                variant="h6"
                                                fontWeight={500}
                                                sx={{ fontFamily: "Poppins", color: "#585857" }}
                                            >
                                                Monto{" "}
                                                <Box component="span" sx={{ color: "#2a8d74", fontWeight: 500 }}>
                                                    
                                               
                                                 {MontoTotalMensual.total_sesiones
  ? `total ${MontoTotalMensual.total_sesiones}`
  : " Sin información"}

                                                        
                                                </Box>
                                            </Typography>
                                        </Box>
            
                                        <Box>
                                            <MdOutlineGroups2 size={60} color="#5cd09aff" />
                                        </Box>
                                    </CardContent>
                                </Card>
              </Box>
           </Grid>
           
 {MontoTotalMensualSucursal?.map((sucursal) => {
  
  return (
      <Grid size={{xs:12, sm:6, md:4}} key={sucursal.branch_id} >
          <Box sx={{ width: "100%", }}>
            <Card
                                    sx={{
                                        
                                        backgroundColor: "#ffffff",
                                        borderRadius: 3,
                                        boxShadow: "0px 4px 10px rgba(42, 103, 69, 0.4)",
                                        transition: "transform 0.2s, box-shadow 0.2s",
                                    }}
                                >
                                    <CardContent
                                        sx={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                width: "100%",
                                                display: "flex",
                                                flexDirection: "column",
                                                justifyContent: "center",
                                                alignItems: "flex-start",
                                                gap: 1,
                                                mb:1
                                            }}
                                        >
                                            <Typography
                                                variant="h5"
                                                fontWeight={400}
                                                sx={{ fontFamily: "Poppins", color: "#585857" }}
                                            >

                                             Sesiones pagadas   {sucursal.sucursal}
                                            </Typography>
            
                                            <Typography
                                                variant="h6"
                                                fontWeight={500}
                                                sx={{ fontFamily: "Poppins", color: "#585857" }}
                                            >
                                                Total{" "}
                                                <Box component="span" sx={{ color: "#2a8d74", fontWeight: 500 }}>
                                                    
                                                 Monto Mes {sucursal.total_sesiones_pagadas} 
                                                        
                                                </Box>
                                            </Typography>
                                        </Box>
            
                                        <Box>
                                            <MdOutlineGroups2 size={60} color="#5cd09aff" />
                                        </Box>
                                    </CardContent>
                                </Card>
              </Box>
           </Grid>

   

  )})}
         </Grid> 
         </Grid> */}

  <Grid size={12} mt={2} mb={2}>
               <Typography variant="h6" sx={{...TituloPrincipal, mt:2, mb:2}}>
  Resumen de pagos ingreso y reingreso {PeriodoMensual.nombre_mes} {PeriodoMensual.anio}
</Typography>
            <Grid container spacing={2} >
        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
  <Card
    sx={{
      backgroundColor: "#ffffff",
      borderRadius: 3,
      boxShadow: "0px 4px 10px rgba(42, 103, 69, 0.4)",
    }}
  >
    <CardContent>
      <Typography variant="h6" sx={{ ...SubTitulo }}>
             Resumen de pagos ingreso y reingreso General
      </Typography>

      {hayInfoPagos ? (
        <Grid container spacing={2}>
          <Grid size={4}>
            <Typography sx={{ fontFamily: "Poppins", color: "#22324A", fontWeight: 600 }}>
              Pacientes
            </Typography>
            <Typography variant="h5" sx={{ fontFamily: "Poppins", color: "#22324A", fontWeight: 500 }}>
              {totalPacientes}
            </Typography>
          </Grid>

          <Grid size={4}>
            <Typography sx={{ fontFamily: "Poppins", color: "#22324A", fontWeight: 600 }}>
              Pagados
            </Typography>
            <Typography variant="h5" sx={{ color: "#2a8d74", fontWeight: 500 }}>
              {porcentajePagados}%
            </Typography>
          </Grid>

          <Grid size={4}>
            <Typography sx={{ fontFamily: "Poppins", color: "#22324A", fontWeight: 600 }}>
              No pagados
            </Typography>
            <Typography variant="h5" sx={{ color: "#d32f2f", fontWeight: 500 }}>
              {porcentajePendientes}%
            </Typography>
          </Grid>
        </Grid>
      ) : (
        <Box
          sx={{
            height: 120,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            color: "#9e9e9e",
            gap: 1,
          }}
        >
          <MdInfoOutline size={40} />
          <Typography sx={{ fontFamily: "Poppins" }}>
            Sin información de pagos
          </Typography>
        </Box>
      )}
    </CardContent>
  </Card>
</Grid>

{MontoTotalMensualSucursal.map((sucursal) => {

  const resumenPagos = sucursal?.resumen_pagos || {};

  const totalPacientes =
    resumenPagos?.pacientes?.total || 0;

  const porcentajePagados =
    resumenPagos?.porcentajes?.pagados || 0;

  const porcentajePendientes =
    resumenPagos?.porcentajes?.pendientes || 0;

  return (
    <Grid size={{ xs: 12, sm: 6, md: 4 }} key={sucursal.branch_id}>
      <Card
        sx={{
          backgroundColor: "#ffffff",
          borderRadius: 3,
          boxShadow: "0px 4px 10px rgba(42, 103, 69, 0.4)",
        }}
      >
        <CardContent>
          <Typography variant="h6" sx={{ ...SubTitulo }}>
            Resumen de pagos ingreso y reingreso {sucursal.sucursal}
          </Typography>

          <Grid container spacing={2}>
            <Grid size={4}>
              <Typography sx={{ fontFamily: "Poppins", color: "#22324A", fontWeight: 600 }}>
                Pacientes
              </Typography>
              <Typography variant="h5" sx={{ color: "#22324A", fontWeight: 500 }}>
                {totalPacientes}
              </Typography>
            </Grid>

            <Grid size={4}>
              <Typography sx={{ fontFamily: "Poppins", color: "#22324A", fontWeight: 600 }}>
                Pagados
              </Typography>
              <Typography variant="h5" sx={{ color: "#2a8d74", fontWeight: 500 }}>
                {porcentajePagados}%
              </Typography>
            </Grid>

            <Grid size={4}>
              <Typography sx={{ fontFamily: "Poppins", color: "#22324A", fontWeight: 600 }}>
                Pendientes
              </Typography>
              <Typography variant="h5" sx={{ color: "#d32f2f", fontWeight: 500 }}>
                {porcentajePendientes}%
              </Typography>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  );
})}
</Grid>
</Grid>

<Grid size={12} mt={2} mb={2}>
               <Typography variant="h6" sx={{...TituloPrincipal, mt:2, mb:2}}>
 Detalle general {PeriodoMensual.nombre_mes} {PeriodoMensual.anio}
</Typography>
            <Grid container spacing={2} >
           <Grid size={{ xs: 12, sm: 6, md: 4 }}>
  <Card
    sx={{
      backgroundColor: "#ffffff",
      borderRadius: 3,
      boxShadow: "0px 4px 10px rgba(42, 103, 69, 0.4)",
    }}
  >
    <CardContent>
      <Typography
        variant="h6"
        sx={{ ...SubTitulo, color: "#22324A", mb: 2 }}
      >
        Pagos recibidos global
      </Typography>

      {detallePacientes?.length > 0 &&
      Number(MontoTotalMensual?.pacientes?.total?.cantidad) > 0 ? (
        <>
          {/* ENCABEZADOS */}
          <Grid container sx={{ mb: 1 }}>
            <Grid size={4}>
              <Typography fontWeight={600}>Tipo</Typography>
            </Grid>
            <Grid size={4} textAlign="center">
              <Typography fontWeight={600}>Cantidad</Typography>
            </Grid>
            <Grid size={4} textAlign="right">
              <Typography fontWeight={600}>Monto</Typography>
            </Grid>
          </Grid>

          {/* FILAS */}
          {detallePacientes.map((item, index) => (
            <Grid
              container
              key={index}
              sx={{
                mb: 1,
                py: 0.5,
                borderBottom: "1px dashed #e0e0e0",
              }}
            >
              <Grid size={4}>
                <Typography fontWeight={500}>
                  {item.tipo}
                </Typography>
              </Grid>

              <Grid size={4} textAlign="center">
                <Typography fontWeight={500}>
                  {item.cantidad}
                </Typography>
              </Grid>

              <Grid size={4} textAlign="right">
                <Typography
                  sx={{ color: "#2a8d74", fontWeight: 500 }}
                >
                  ${item.monto.toLocaleString("es-CL")}
                </Typography>
              </Grid>
            </Grid>
          ))}

          {/* TOTAL */}
          <Grid
            container
            sx={{
              mt: 2,
              pt: 1.5,
              borderTop: "2px solid #e0e0e0",
            }}
          >
            <Grid size={4}>
              <Typography fontWeight={600}>Total</Typography>
            </Grid>

            <Grid size={4} textAlign="center">
              <Typography fontWeight={500}>

              </Typography>
            </Grid>

            <Grid size={4} textAlign="right">
              <Typography fontWeight={500}>
                $
                {Number(
                  MontoTotalMensual.pacientes.total.monto
                ).toLocaleString("es-CL")}
              </Typography>
            </Grid>
          </Grid>
        </>
      ) : (
        // 🔴 SIN INFORMACIÓN
        <Box
          sx={{
             height: 140,
            py: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            color: "#9e9e9e",
          }}
        >
          <MdInfoOutline size={40} />
          <Typography fontSize={14} sx={{ fontFamily: "Poppins" }}>
            Sin información
          </Typography>
        </Box>
      )}
    </CardContent>
  </Card>
</Grid>
{MontoTotalMensualSucursal?.map((sucursal) => {
    
    const detallePacientesSucursalMensual =
    obtenerDetallePacientes(sucursal.pacientes);


  return (
     <Grid size={{ xs: 12, sm: 6, md: 4 }} key={sucursal.branch_id}>
         <Card
  sx={{
    backgroundColor: "#ffffff",
    borderRadius: 3,
    boxShadow: "0px 4px 10px rgba(42, 103, 69, 0.4)",
  }}
>
  <CardContent>
    <Typography
      variant="h6"
      sx={{ ...SubTitulo, color: "#22324A", mb: 2 }}
    >
      Pagos recibidos {sucursal.sucursal}
    </Typography>

    {/* ENCABEZADOS */}
    <Grid container sx={{ mb: 1}}>
      <Grid size={4}>
         <Typography sx={{ textTransform: "capitalize", fontFamily:'Poppins', color: "#22324A", fontWeight:'600' }}>Tipo</Typography>
      </Grid>
      <Grid size={4} textAlign="center">
         <Typography sx={{ textTransform: "capitalize", fontFamily:'Poppins', color: "#22324A", fontWeight:'600' }}>Cantidad</Typography>
      </Grid>
      <Grid size={4} textAlign="right">
        <Typography sx={{ textTransform: "capitalize", fontFamily:'Poppins', color: "#22324A", fontWeight:'600' }}>Monto</Typography>
      </Grid>
    </Grid>

    {detallePacientesSucursalMensual.map((item, index) => (
            <Grid container key={index} sx={{ mb: 1 }}>
              <Grid size={4}>
                {item.tipo}
              </Grid>
              <Grid size={4} textAlign="center">
                {item.cantidad}
              </Grid>
              <Grid size={4} textAlign="right">
                ${item.monto.toLocaleString("es-CL")}
              </Grid>
            </Grid>
          ))}

          {/* TOTAL */}
          <Grid container sx={{ mt: 2, borderTop: "1px solid #ddd", pt: 1 }}>
            <Grid size={4}>Total</Grid>
            <Grid size={4} textAlign="center">
              {sucursal.pacientes?.total?.cantidad}
            </Grid>
            <Grid size={4} textAlign="right">
              $
              {Number(
                sucursal.pacientes?.total?.monto
              ).toLocaleString("es-CL")}
            </Grid>

   
   
    </Grid>
  </CardContent>
</Card>
      </Grid>
  )})}
  </Grid>
  </Grid>

<Grid size={12} mt={2} mb={2}>
               <Typography variant="h6" sx={{...TituloPrincipal, mt:2, mb:2}}>
 Estado de pago ingresos y reingresos {PeriodoMensual.nombre_mes} {PeriodoMensual.anio}
</Typography>
            <Grid container spacing={2} >
            <Grid size={{ xs: 12, sm: 4 }} >
  <Card
    sx={{
      backgroundColor: "#ffffff",
      borderRadius: 3,
      boxShadow: "0px 4px 10px rgba(42, 103, 69, 0.4)",
    }}
  >
    <CardContent>
      <Typography
        variant="h6"
        sx={{ ...SubTitulo, color: "#22324A", mb: 2 }}
      >
        Estado de pago ingresos y reingresos
      </Typography>

  {hasDataPagosIngresoReingreso ? (
  <ResponsiveContainer width="100%" height={200}>
    <BarChart
      data={chartPagosIngresoReingreso}
      layout="vertical"
      margin={{ top: 20, right: 30, left: 60, bottom: 20 }}
    >
      <CartesianGrid strokeDasharray="3 3" />

      <XAxis
        type="number"
        tick={{
          fontSize: 11,
          fontFamily: "Poppins",
          fill: "#585857",
          fontWeight: 600,
        }}
      />

      <YAxis
        type="category"
        dataKey="tipo"
        width={90}
        tick={{
          fontSize: 12,
          fontFamily: "Poppins",
          fill: "#585857",
          fontWeight: 600,
        }}
      />

      <Tooltip />
      <Bar dataKey="pagados" fill="#4c9470" name="Pagados" />
      <Bar dataKey="pendientes" fill="#d9534f" name="Pendientes" />
    </BarChart>
  </ResponsiveContainer>
) : (
  <Box
    sx={{
      height: 200,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      color: "#9e9e9e",
    }}
  >
    <BarChartOutlinedIcon sx={{ fontSize: 48, mb: 1 }} />
    <Typography
      sx={{
        fontFamily: "Poppins",
        fontSize: 13,
        fontWeight: 500,
        textAlign: "center",
      }}
    >
      No existe información disponible
    </Typography>
  </Box>
)}


    </CardContent>
  </Card>
</Grid>

{MontoTotalMensualSucursal?.map((sucursal) => {
 
    const detalleingresoyreingresosucursal = sucursal?.montos_por_estado;
   

const chartPagosIngresoReingresosucursal = detalleingresoyreingresosucursal
  ? [
      {
        tipo: "Ingreso",
        pagados: Number(detalleingresoyreingresosucursal.ingreso?.pagados.cantidad || 0),
        pendientes: Number(detalleingresoyreingresosucursal.ingreso?.pendientes.cantidad || 0),
      },
      {
        tipo: "Reingreso",
        pagados: Number(detalleingresoyreingresosucursal.reingreso?.pagados.cantidad || 0),
        pendientes: Number(detalleingresoyreingresosucursal.reingreso?.pendientes.cantidad || 0),
      },
    ]
  : [];
  return (
     <Grid size={{ xs: 12, sm: 6, md: 4 }} key={sucursal.branch_id}>
      <Card
    sx={{
      backgroundColor: "#ffffff",
      borderRadius: 3,
      boxShadow: "0px 4px 10px rgba(42, 103, 69, 0.4)",
    }}
  >
    <CardContent>
      <Typography
        variant="h6"
        sx={{ ...SubTitulo, color: "#22324A", mb: 2 }}
      >
        Estado de pago ingresos y reingresos {sucursal.sucursal}
      </Typography>

    <ResponsiveContainer width="100%" height={200}>
  <BarChart
    data={chartPagosIngresoReingresosucursal}
    layout="vertical"
    margin={{ top: 20, right: 30, left: 60, bottom: 20 }}
  >
    <CartesianGrid strokeDasharray="3 3" />

    {/* Eje X = cantidad */}
    <XAxis
      type="number"
      tick={{
        fontSize: 11,
        fontFamily: "Poppins",
        fill: "#585857",
        fontWeight: 600,
      }}
    />

    {/* Eje Y = tipo */}
    <YAxis
      type="category"
      dataKey="tipo"
      tick={{
        fontSize: 12,
        fontFamily: "Poppins",
        fill: "#585857",
        fontWeight: 600,
      }}
    />

    <Tooltip />

    {/* Barras */}
    <Bar dataKey="pagados" fill="#4c9470" name="Pagados" />
    <Bar dataKey="pendientes" fill="#d9534f" name="pendientes" />
  </BarChart>
</ResponsiveContainer>

    </CardContent>
  </Card>
      </Grid>
  )})}

  </Grid>
  </Grid>

          <Grid size={12} mt={2} mb={2}>
               <Typography variant="h6" sx={{...TituloPrincipal, mt:2, mb:2}}>
  Detalle deudores {PeriodoMensual.nombre_mes} {PeriodoMensual.anio}
</Typography>
            <Grid container spacing={2} >
           <Grid size={{xs:12, sm:6, md:4}} >
              <Card
                                    sx={{
                                       
                                        backgroundColor: "#ffffff",
                                        borderRadius: 3,
                                        boxShadow: "0px 4px 10px rgba(42, 103, 69, 0.4)",
                                        transition: "transform 0.2s, box-shadow 0.2s",
                                    }}
                                >
                                  {hayDeudores ? (
                                     
                                    <CardContent
                                        sx={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                        }}
                                    >     
                                    <Box sx={{width:'40%', display:'flex', alignItems:'center', justifyContent:'center', flexDirection:'column'}}>
                                       <Typography
                                                variant="h6"
                                                fontWeight={400}
                                                sx={{ fontFamily: "Poppins", color: "#585857" }}
                                            >

                                             Deudores totales del mes {PeriodoMensual.nombre_mes} {PeriodoMensual.anio}
                                            
                                            </Typography>
                                             <Typography
                                                variant="h4"
                                                fontWeight={400}
                                                sx={{ fontFamily: "Poppins", color: "#585857" }}
                                            >

                                           
                                             <Box component="span" sx={{ color: "#2a8d74", fontWeight: 500 }}>
                                                    
                                                    {MontoTotalMensual.deudores}
                                                        
                                                </Box>
                                            </Typography>
                                      </Box>
                                            <Box sx={{ width: "100%", height: 400 }}>
                                      
        
    <ResponsiveContainer >
      <PieChart>
        <Pie
          data={dataDeudoresTotaltesMensual}
          dataKey="value"
          nameKey="name"
          innerRadius={50}
          outerRadius={80}
          paddingAngle={3}
        >
          {dataDeudoresTotaltesMensual.map((_, index) => (
            <Cell
              key={index}
              fill={COLORS[index % COLORS.length]}
            />
          ))}
        </Pie>

        <Tooltip formatter={(value, name) => [`${value} deudores`, name]} />
        <Legend verticalAlign="bottom" />
      </PieChart>
    </ResponsiveContainer>
 
             </Box>
          
             
             </CardContent> ) : (
    <Box
    sx={{
      height: 280,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      color: "#9e9e9e",
    }}
  >
    <BarChartOutlinedIcon sx={{ fontSize: 48, mb: 1 }} />
    <Typography
      sx={{
        fontFamily: "Poppins",
        fontSize: 13,
        fontWeight: 500,
        textAlign: "center",
      }}
    >
      No hay deudores registrado
    </Typography>
  </Box>
  )}
             </Card>
             
               
           </Grid>

           {MontoTotalMensualSucursal?.map((sucursal) => {
             const deudoresSucursal =
  sucursal?.deudores?.por_prevision || [];

const dataDeudoresTotaltesMensualSucursal = deudoresSucursal.map(item => ({
  name: item.prevision,
  value: Number(item.cantidad_deudores || 0),
}));


const hasDeudoressucursal =
  dataDeudoresTotaltesMensualSucursal.length > 0 &&
  dataDeudoresTotaltesMensualSucursal.some(item => item.value > 0);
  
  return (
     <Grid size={{ xs: 12, sm: 6, md: 4 }} key={sucursal.branch_id}>
         <Card
                                    sx={{
                                      
                                        backgroundColor: "#ffffff",
                                        borderRadius: 3,
                                        boxShadow: "0px 4px 10px rgba(42, 103, 69, 0.4)",
                                        transition: "transform 0.2s, box-shadow 0.2s",
                                    }}
                                >   
                                {hasDeudoressucursal ? (
                                    <CardContent
                                        sx={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                        }}
                                    > 
                                    <Box sx={{width:'40%', display:'flex', alignItems:'center', justifyContent:'center', flexDirection:'column'}}>
                                       <Typography
                                                variant="h6"
                                                fontWeight={400}
                                                sx={{ fontFamily: "Poppins", color: "#585857" }}
                                            >

                                             Deudores {sucursal.sucursal} del mes {PeriodoMensual.nombre_mes} {PeriodoMensual.anio}
                                            
                                            </Typography>
                                             <Typography
                                                variant="h4"
                                                fontWeight={400}
                                                sx={{ fontFamily: "Poppins", color: "#585857" }}
                                            >

                                           
                                             <Box component="span" sx={{ color: "#2a8d74", fontWeight: 500 }}>
                                                    
                                                    {MontoTotalMensualSucursal.deudores}
                                                        
                                                </Box>
                                            </Typography>
                                      </Box>
                                            <Box sx={{ width: "100%", height: 400 }}>
                                      
              <ResponsiveContainer>
        <PieChart>
           <Pie
        data={dataDeudoresTotaltesMensualSucursal}
        dataKey="value"
        nameKey="name"
        innerRadius={50}
        outerRadius={80}
        paddingAngle={3}
      >
        {dataDeudoresTotaltesMensualSucursal.map((_, index) => (
          <Cell
            key={`cell-${index}`}
            fill={COLORS[index % COLORS.length]}
          />
        ))}
      </Pie>

          <Tooltip
            formatter={(value, name) => [`${value} deudores`, name]}
          />
          <Legend verticalAlign="bottom" />
        </PieChart>
      </ResponsiveContainer>
             </Box>
             </CardContent>
             ) : (
    <Box
    sx={{
      height: 280,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      color: "#9e9e9e",
    }}
  >
    <BarChartOutlinedIcon sx={{ fontSize: 48, mb: 1 }} />
    <Typography
      sx={{
        fontFamily: "Poppins",
        fontSize: 13,
        fontWeight: 500,
        textAlign: "center",
      }}
    >
      No hay deudores registrado {sucursal.sucursal}
    </Typography>
  </Box>
  )}
             </Card>
      </Grid>
  )})}
  </Grid>
  </Grid>
         <Grid size={12} mt={2} mb={2}>
               <Typography variant="h6" sx={{...TituloPrincipal, mt:2, mb:2}}>
  Detalle por Prevision  {PeriodoMensual.nombre_mes} {PeriodoMensual.anio}
</Typography>
            <Grid container spacing={2} >
            <Grid size={{xs:12,sm:6}}>
               <Card
  sx={{
    width: "100%",  
    backgroundColor: "#ffffff",
    borderRadius: 3,
    boxShadow: "0px 4px 10px rgba(42, 103, 69, 0.4)",
  }}
>
  <CardContent>
    <Typography
      variant="h6"
      sx={{ ...SubTitulo, color: "#22324A", mb: 2 }}
    >
      Detalle de previsiones global
    </Typography>
          <Box sx={{ width: "100%", height: 600 }}>
  {hayPrevisiones ? (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart
        data={chartDataPrevisionesmensual}
        layout="vertical"
        margin={{ top: 20, right: 30, left: 0, bottom: 20 }}
      >
        <CartesianGrid strokeDasharray="3 3" />

        <XAxis
          type="number"
          tick={{
            fontSize: 11,
            fontFamily: "Poppins",
            fill: "#585857",
            fontWeight: 600,
          }}
          tickFormatter={(value) =>
            new Intl.NumberFormat("es-CL", {
              notation: "compact",
              compactDisplay: "short",
            }).format(value)
          }
        />

        <YAxis
          type="category"
          dataKey="name"
          tick={{
            fontSize: 11,
            fontFamily: "Poppins",
            fill: "#585857",
            fontWeight: 600,
          }}
          width={180}
        />

        <Tooltip
          formatter={(value) => [
            new Intl.NumberFormat("es-CL", {
              style: "currency",
              currency: "CLP",
            }).format(value),
            "Monto total",
          ]}
          labelFormatter={(label) => `Previsión: ${label}`}
        />

        <Bar dataKey="monto" fill="#4c9470ff" name="Monto total" />
      </BarChart>
    </ResponsiveContainer>
  ) : (
     <Box
    sx={{
      height: 280,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      color: "#9e9e9e",
    }}
  >
    <BarChartOutlinedIcon sx={{ fontSize: 48, mb: 1 }} />
      <Typography
        sx={{
          fontFamily: "Poppins",
          fontSize: 14,
          color: "#9e9e9e",
          fontWeight: 500,
        }}
      >
        Sin información de previsiones
      </Typography>
    </Box>
  )}
</Box>

</CardContent>
</Card>

            </Grid>

            {MontoTotalMensualSucursal?.map((sucursal) => {
              
  
const chartDataPrevisionesmensualsucursal =
  sucursal?.previsiones?.map(item => ({
    name: item.prevision,
    monto: Number(item.total_monto),
    pacientes: item.total_pacientes,
  })) || [];
 
  
  return (
      <Grid size={{xs:12,sm:6}}  key={sucursal.branch_id}>
               <Card
  sx={{
    width: "100%",  
    backgroundColor: "#ffffff",
    borderRadius: 3,
    boxShadow: "0px 4px 10px rgba(42, 103, 69, 0.4)",
  }}
>
  <CardContent>
    <Typography
      variant="h6"
      sx={{ ...SubTitulo, color: "#22324A", mb: 2 }}
    >
      Detalle de previsiones {sucursal.sucursal}
    </Typography>
              <Box sx={{ width: "100%", height: 600  }}>
 <ResponsiveContainer width="100%" height="100%">
    <BarChart
      data={chartDataPrevisionesmensualsucursal}
      layout="vertical"
      margin={{ top: 20, right: 30, left: 0, bottom: 20 }}
    >
      <CartesianGrid strokeDasharray="3 3" />

      {/* Eje horizontal = monto */}
      <XAxis
        type="number"
        tick={{ fontSize: 11, fontFamily: 'Poppins', fill: "#585857", fontWeight: 600 }}
        tickFormatter={(value) =>
          new Intl.NumberFormat('es-CL', {
            notation: 'compact',
            compactDisplay: 'short',
          }).format(value)
        }
      />

      {/* Eje vertical = previsiones */}
      <YAxis
        type="category"
        dataKey="name"
        tick={{ fontSize: 11, fontFamily: 'Poppins', fill: "#585857", fontWeight: 600 }}
        width={130}
      />

      <Tooltip
        formatter={(value, name, props) => [
          new Intl.NumberFormat('es-CL', {
            style: 'currency',
            currency: 'CLP',
          }).format(value),
          'Monto total',
        ]}
        labelFormatter={(label) => `Previsión: ${label}`}
      />

      <Bar dataKey="monto" fill="#4c9470ff" name="Monto total" />
    </BarChart>
  </ResponsiveContainer>
</Box>
</CardContent>
</Card>

            </Grid>
  )})}
  </Grid>
  </Grid>
      
<Grid size={12} mt={2} mb={2}>
               <Typography variant="h6" sx={{...TituloPrincipal, mt:2, mb:2}}>
  Detalle por Kinesiólogo  {PeriodoMensual.nombre_mes} {PeriodoMensual.anio}
</Typography>
            <Grid container spacing={2} >
 {MontoTotalMensualSucursal?.map((sucursal) => {
  
  
const kinesiologossucursal =
  sucursal?.kines || [];




const chartDataKinesucursal = kinesiologossucursal
  .map(item => ({
    name: item.kine, // 👈 este es el nombre real
    ingreso: Number(item.montos?.ingreso || 0),
    reingreso: Number(item.montos?.reingreso || 0),
    terapia: Number(item.montos?.terapia || 0),
    total:
      Number(item.montos?.total || 0) 
  }))
  // 🔽 ordenados de mayor a menor por total
  .sort((a, b) => b.total - a.total);
  return (
      <Grid size={{xs:12,sm:6}}  key={sucursal.branch_id}>
           <Card
    sx={{
      backgroundColor: "#ffffff",
      borderRadius: 3,
      boxShadow: "0px 4px 10px rgba(42, 103, 69, 0.4)",
    }}
  >
    <CardContent>
      <Typography
        variant="h6"
        sx={{ ...SubTitulo, color: "#22324A", mb: 2 }}
      >
        Detalle por Kinesiólogo {sucursal.sucursal}
      </Typography>

      <ResponsiveContainer width="100%" height={450}>
        <BarChart
          data={chartDataKinesucursal}
          margin={{ top: 20, right: 30, left: 0, bottom: 60 }}
        >
          <CartesianGrid strokeDasharray="3 3" />

          {/* Eje X = Kinesiólogos */}
          <XAxis
            dataKey="name"
            angle={-30}
            textAnchor="end"
            interval={0}
            tick={{
              fontSize: 11,
              fontFamily: "Poppins",
              fill: "#585857",
              fontWeight: 600,
            }}
          />

          {/* Eje Y = cantidad */}
          <YAxis
            tick={{
              fontSize: 11,
              fontFamily: "Poppins",
              fill: "#585857",
              fontWeight: 600,
            }}
          />

          <Tooltip  
          formatter={(value, _name, props) => {
    const key = props.dataKey;

    const labels = {
      ingreso: "Ingreso",
      reingreso: "Reingreso",
      terapia: "Terapia",
      total:" total"
    };

    return [formatCLP(value), labels[key] || key];
  }}
  labelFormatter={(label) => `Kinesiólogo: ${label}`} />

          {/* 🔹 Barras por estado */}
          <Bar dataKey="ingreso" fill="#4c9470" name="Ingreso" />
          <Bar dataKey="reingreso" fill="#2a8fd4" name="Reingreso" />
          <Bar dataKey="terapia" fill="#f2b705" name="Terapia" />
            <Bar dataKey="total" fill="#09a309" name="Total" />
          
        </BarChart>
      </ResponsiveContainer>
    </CardContent>
  </Card>
        </Grid>
  )})}
</Grid>
          
</Grid>


       
        </Grid>
             
                            </Box>
    </Box>
  <Box sx={{ mt: 3, mb: 5 }}>
  <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
 <DatePicker
  label="Seleccionar fecha (semana)"
  value={fechaSeleccionada}
  onChange={(date) => {
    if (!date) return;

    setFechaSeleccionada(date);

    setFiltros({
      anio: date.weekYear(), // ISO correcto
      semana: date.week(),
    });
  }}
  slotProps={{
    textField: {
      size: "small",
      fullWidth: true,
    },
  }}
/>





      
  </LocalizationProvider>
</Box>


    {/* titulo */}
    <Typography variant="h6" sx={{...TituloPrincipal, mt:2}}>
  Período  {inicioFormateado} al {finFormateado}
</Typography>


      {/* Tabs por sucursal */}
      <Tabs
        value={tabIndex}
        onChange={(e, newIndex) => setTabIndex(newIndex)}
       variant="scrollable"   // 👈 evita que se estiren a todo el ancho
                            scrollButtons={false}
                            TabIndicatorProps={{
                                style: {
                                    backgroundColor: "#6fd385ff", // 👈 mismo verde del tab activo
                                    height: "3px",             // 👈 grosor de la línea
                                    borderRadius: "2px",       // 👈 opcional, línea más suave
                                },
                            }}
                            sx={{
                                mt:4,
                                "& .MuiTab-root": {
                                    minWidth: "auto",
                                    px: 2,
                                    textTransform: "none",
                                    fontFamily: "Poppins",
                                    fontWeight: 500,
                                    borderRadius: " 0 0", // 👈 esquinas redondeadas arriba (opcional)
                                     backgroundColor: "#aae8d861",
                                },
                                "& .Mui-selected": {
                                    fontWeight: 600,
                                    backgroundColor: "#3cb29461", // 👈 verde oscuro
                                    color: "#244b3fff !important",   // 👈 letras blancas
                                },
                            }}
        
      >
        {sucursales.map((sucursal, index) => (
          <Tab key={sucursal.branch_id} label={sucursal.branch_nombre} />
        ))}
      </Tabs>

      {/* Contenido del tab activo */}
      {sucursales.map((sucursal, index) => {
        if (index !== tabIndex) return null;

         const { pacientes } = sucursal;
       
        // Preparamos el desglose de pacientes
        const pacientesKeys = Object.keys(pacientes || {});

        const pacientesFiltrados = pacientesKeys.filter(
  (key) => (pacientes[key]?.monto || 0) > 0
);


        return (
          <Box key={sucursal.branch_id}>
            <Paper
              sx={{
                
                borderRadius: 3,
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0)",
              }}
            >
             
                <Grid container>
                <Grid size={{xs:12, sm:6, md:2}} sx={{ display:'flex', alignItems:'center', justifyContent:'center'}}>
                     <Box sx={{
                     p: 1,
                     width:'80%',
                     border:'1px solid #a2d6c2ff',
                    borderRadius: 3,
                    boxShadow: "0px 4px 12px rgba(33, 32, 32, 0)",
                    display:'flex',
                    alignItems:'center',
                    justifyContent:'center',
                    flexDirection:'column'
                }}>
              <Typography sx={{ mb: 1, fontWeight: "600", fontSize: "0.9rem", fontFamily:'Poppins', color:'#585857'}}>
                Total Semanal
              </Typography>
              <Typography sx={{ fontSize: "1.3rem", fontWeight: "600", color: "#4c9470ff", fontFamily:'Poppins', }}>
                {formatCLP(sucursal.total_semanal)}
              </Typography>
              </Box>
                </Grid>
                
                  <Grid size={{xs:12, sm:6, md:4}}>
                    
                   <Box
  sx={{
    p: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
  }}
>
  <Typography
    sx={{
      mb: 1,
      fontWeight: "600",
      fontSize: "0.9rem",
      fontFamily: "Poppins",
      color: "#585857",
    }}
  >
    DETALLE TOTAL PAGO PACIENTES
  </Typography>

  {pacientesFiltrados.length === 0 ? (
    // 🔴 SIN INFORMACIÓN
    <Box
      sx={{
        height: 280,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        color: "#9e9e9e",
      }}
    >
      <BarChartOutlinedIcon sx={{ fontSize: 48, mb: 1 }} />
      <Typography
        sx={{
          fontFamily: "Poppins",
          fontSize: 13,
          fontWeight: 500,
          textAlign: "center",
        }}
      >
        Sin información
      </Typography>
    </Box>
  ) : (
    // 🟢 CON INFORMACIÓN
    pacientesFiltrados.map((key) => {
      const pacienteData = pacientes[key];
      const cantidad = pacienteData?.cantidad || 0;
      const monto = pacienteData?.monto || 0;

      return (
       <Box
  key={key}
  sx={{
    display: "flex",
    alignItems: "center",
    width: "80%",
  }}
>
  {/* IZQUIERDA – PAGO */}
  <Typography
    sx={{
      flex: "1 1 60%",
      fontWeight: 500,
      fontSize: "0.9rem",
      fontFamily: "Poppins",
      color: "#585857",
      textTransform: "lowercase",
    }}
  >
    Pagos {key.replace("_", " ").toUpperCase()}
  </Typography>

  {/* CENTRO – CANTIDAD */}
  <Typography
    sx={{
      flex: "0 0 60px",
      textAlign: "center",
      fontWeight: 500,
      fontSize: "0.9rem",
      fontFamily: "Poppins",
    }}
  >
    {cantidad}
  </Typography>

  {/* DERECHA – MONTO */}
  <Typography
    sx={{
      flex: "0 0 120px",
      textAlign: "right",
      color: "#4c9470ff",
      fontWeight: 500,
      fontFamily: "Poppins",
      fontSize: "0.9rem",
    }}
  >
    {formatCLP(monto)}
  </Typography>
</Box>

      );
    })
  )}
</Box>


                  </Grid>

                   <Grid size={{xs:12, sm:6, md:4}} sx={{ borderLeft:'1px solid #4c9470ff'}}>
                  <Box
  sx={{
    p: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
  }}
>
  <Typography
    sx={{
      mb: 1,
      fontWeight: "600",
      fontSize: "0.9rem",
      fontFamily: "Poppins",
      color: "#585857",
    }}
  >
    DETALLE DE PAGOS INGRESOS & REINGRESOS
  </Typography>

  {(() => {
    const ingreso = sucursal.detalle_ingreso_reingreso?.ingreso || {};
    const reingreso = sucursal.detalle_ingreso_reingreso?.reingreso || {};
  
    const ingresoPagados = Number(ingreso.pagados || 0);
    const ingresoPendientes = Number(ingreso.pendientes || 0);
    const reingresoPagados = Number(reingreso.pagados || 0);
    const reingresoPendientes = Number(reingreso.pendientes || 0);

    const totalAtendidos =
      ingresoPagados +
      ingresoPendientes +
      reingresoPagados +
      reingresoPendientes;

    // 🔴 SIN INFORMACIÓN
    if (totalAtendidos === 0) {
      return (
        <Box
          sx={{
            height: 160,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            color: "#9e9e9e",
          }}
        >
          <BarChartOutlinedIcon sx={{ fontSize: 48, mb: 1 }} />
          <Typography
            sx={{
              fontFamily: "Poppins",
              fontSize: 13,
              fontWeight: 500,
              textAlign: "center",
            }}
          >
            Sin información disponible
          </Typography>
        </Box>
      );
    }

  

const porcentajePagados = sucursal.resumen_ingreso_reingreso?.pagados?.porcentaje ||0 ;

const porcentajePendientes =sucursal.resumen_ingreso_reingreso?.no_pagados?.porcentaje || 0;


    const cards = [
      {
        title: "Pacientes Atendidos",
        value: totalAtendidos,
        color: "#4c9470",
      },
      {
        title: "Pagados",
        value: `${porcentajePagados}%`,
        color: "#3278a0",
      },
      {
        title: "Pendientes",
        value: `${porcentajePendientes}%`,
        color: "#7e3626",
      },
    ];

    // 🟢 CON INFORMACIÓN
    return (
      <Grid container spacing={1} sx={{ mt: 2 }}>
        {cards.map((item) => (
          <Grid size={4} key={item.title}>
            <Box
              sx={{
                height: "80px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: 3,
                boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
                backgroundColor: "#f9f9f9",
              }}
            >
              <Typography
                sx={{
                  mb: 1,
                  fontWeight: 500,
                  fontSize: "0.8rem",
                  fontFamily: "Poppins",
                  color: "#585857",
                  textAlign: "center",
                }}
              >
                {item.title}
              </Typography>
              <Typography
                sx={{
                  fontSize: "1.2rem",
                  fontWeight: "600",
                  color: item.color,
                }}
              >
                {item.value}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    );
  })()}
</Box>

                   </Grid>
                    <Grid size={{xs:12, sm:6, md:2}}  sx={{ borderLeft:'1px solid #4c9470ff'}}>
                    <Box
  sx={{
    p: 2,
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    flexDirection: "column",
  }}
>
  <Typography
    sx={{
      mb: 4,
      fontWeight: "600",
      fontSize: "0.9rem",
      fontFamily: "Poppins",
      color: "#585857",
    }}
  >
    RESUMEN ATENCIÓN SEMANAL
  </Typography>

  {Number(sucursal.total_sesiones || 0) > 0 ? (
    // 🟢 CON INFORMACIÓN
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <Typography
        sx={{
          mb: 1,
          fontWeight: "500",
          fontSize: "0.9rem",
          fontFamily: "Poppins",
          color: "#585857",
        }}
      >
        Total sesiones pagadas
      </Typography>

      <Typography
        sx={{
          fontSize: "1.2rem",
          fontWeight: "600",
          color: "#4c9470ff",
          fontFamily: "Poppins",
        }}
      >
        {sucursal.total_sesiones}
      </Typography>
    </Box>
  ) : (
    // 🔴 SIN INFORMACIÓN
    <Box
      sx={{
        height: 120,
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        color: "#9e9e9e",
      }}
    >
      <BarChartOutlinedIcon sx={{ fontSize: 42, mb: 1 }} />
      <Typography
        sx={{
          fontFamily: "Poppins",
          fontSize: 13,
          fontWeight: 500,
          textAlign: "center",
        }}
      >
        Sin información disponible
      </Typography>
    </Box>
  )}
</Box>

                    </Grid>
                      <Grid
  size={{ xs: 12, sm: 6, md: 4 }}
  sx={{
    height: 500, // 🔥 obligatorio
    
    display: "flex",
    flexDirection: "column",
  }}
>
  <Box
  sx={{
    background:"#2a8d7490",
    display:'flex',
    alignItems:'center',
    justifyContent:'center',
    textAlign:'center',
    p:2
  }}
  >

  <Typography
    sx={{
     
      fontWeight: 600,
      fontFamily: "Poppins",
      textAlign: "center",
      color: "#585857",
    }}
  >
     Detalle de monto total
  </Typography>
  </Box>

 <Box sx={{ width: "100%", height: "100%" }}>
  {hasData ? (
    // 🟢 CON INFORMACIÓN
    <ResponsiveContainer width="100%" height="100%">
      <PieChart>
        <Pie
          data={chartData}
          dataKey="value"
          nameKey="name"
          cx="50%"
          cy="50%"
          innerRadius={55}
          outerRadius={140}
          paddingAngle={1}
          label={renderMontoLabel}
          labelLine={false}
        >
          {chartData.map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={["#3278a0", "#4c9470", "#95e2c5", "#b9bb60ff"][index]}
            />
          ))}
        </Pie>

        <Tooltip
          formatter={(value) =>
            Number(value).toLocaleString("es-CL", {
              style: "currency",
              currency: "CLP",
              maximumFractionDigits: 0,
            })
          }
        />

        <Legend
          verticalAlign="bottom"
          align="center"
          layout="horizontal"
          wrapperStyle={{ paddingTop: 10 }}
        />
      </PieChart>
    </ResponsiveContainer>
  ) : (
    // 🔴 SIN INFORMACIÓN
    <Box
      sx={{
        height: "100%",
        minHeight: 280,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        color: "#9e9e9e",
      }}
    >
      <BarChartOutlinedIcon sx={{ fontSize: 48, mb: 1 }} />
      <Typography
        sx={{
          fontFamily: "Poppins",
          fontSize: 13,
          fontWeight: 500,
          textAlign: "center",
        }}
      >
        Sin información disponible
      </Typography>
    </Box>
  )}
</Box>


</Grid>
  <Grid
  size={{ xs: 12, sm: 6, md: 4 }}
  sx={{
    height: 500, // 🔥 obligatorio
    
    display: "flex",
    flexDirection: "column",
  }}
>
  <Box
  sx={{
    background:"#2a8d7490",
    display:'flex',
    alignItems:'center',
    justifyContent:'center',
    textAlign:'center',
    p:2
  }}
  >

  <Typography
    sx={{
     
      fontWeight: 600,
      fontFamily: "Poppins",
      textAlign: "center",
      color: "#585857",
    }}
  >
    Estado de pago ingresos y reingresos
  </Typography>
  </Box>

  <Box sx={{ flex: 1, p: 2, borderLeft: "1px solid #4c9470ff" }}>
  {hasDataEstadoPago ? (
    // 🟢 CON INFORMACIÓN
    <ResponsiveContainer width="100%" height="100%">
      <BarChart
        data={chartDataEstadoPagoIngresoReingreso}
        layout="vertical"
        margin={{ left: 30, right: 20 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          type="number"
          tick={{
            fontSize: 11,
            fontFamily: "Poppins",
            color: "#585857",
            fontWeight: 600,
          }}
        />
        <YAxis
          dataKey="estado"
          type="category"
          width={90}
          tick={{
            fontSize: 11,
            fontFamily: "Poppins",
            color: "#585857",
            fontWeight: 600,
          }}
        />
        <Tooltip />
        <Legend />

        {/* Ingreso */}
        <Bar
          dataKey="ingreso"
          name="Ingreso"
          fill="#3278a0"
          radius={[0, 6, 6, 0]}
        />

        {/* Reingreso */}
        <Bar
          dataKey="reingreso"
          name="Reingreso"
          fill="#4c9470"
          radius={[0, 6, 6, 0]}
        />
      </BarChart>
    </ResponsiveContainer>
  ) : (
    // 🔴 SIN INFORMACIÓN
    <Box
      sx={{
        height: "100%",
        minHeight: 280,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        color: "#9e9e9e",
      }}
    >
      <BarChartOutlinedIcon sx={{ fontSize: 48, mb: 1 }} />
      <Typography
        sx={{
          fontFamily: "Poppins",
          fontSize: 13,
          fontWeight: 500,
          textAlign: "center",
        }}
      >
        Sin información disponible
      </Typography>
    </Box>
  )}
</Box>

  </Grid>
  {/* % Total de pagos ingresos y renigresos */}
  <Grid
  size={{ xs: 12, sm: 6, md: 4 }}
  sx={{
    height: 500, // 🔥 obligatorio
    
    display: "flex",
    flexDirection: "column",
  }}
>
  <Box
  sx={{
    
    background:"#2a8d7490",
    display:'flex',
    alignItems:'center',
    justifyContent:'center',
    textAlign:'center',
    p:2
  }}
  >

  <Typography
    sx={{
     
      fontWeight: 600,
      fontFamily: "Poppins",
      textAlign: "center",
      color: "#585857",
    }}
  >
 % Total de pagos ingresos y renigresos
  </Typography>
  </Box>
  <Box sx={{ flex: 1, p: 2, borderLeft: '1px solid #4c9470ff' }}>
  {hasDataPagosingresoReingresosSemanal ? (
    <ResponsiveContainer width="100%" height="100%">
      <PieChart>
        <Pie
          data={chartDataporcentualingresoreingreso}
          dataKey="value"
          nameKey="name"
          cx="50%"
          cy="40%"
          innerRadius={60}
          outerRadius={140}
          paddingAngle={2}
          label={renderLabel}
          labelLine={false}
        >
          <Cell fill="#4c9470b5" />
          <Cell fill="#7e2626a7" />
        </Pie>

        <Tooltip formatter={(value) => `${value} pacientes`} />
        <Legend verticalAlign="bottom" />
      </PieChart>
    </ResponsiveContainer>
  ) : (
    // 🔴 SIN INFORMACIÓN
    <Box
      sx={{
        height: "100%",
        minHeight: 280,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        color: "#9e9e9e",
      }}
    >
      <BarChartOutlinedIcon sx={{ fontSize: 48, mb: 1 }} />
      <Typography
        sx={{
          fontFamily: "Poppins",
          fontSize: 13,
          fontWeight: 500,
          textAlign: "center",
        }}
      >
        Sin información disponible
      </Typography>
    </Box>
  )}
</Box>


  {/* Total visible */}
  <Box sx={{ textAlign: "center", pb: 1 }}>
    <Typography sx={{ fontFamily: "Poppins", fontSize: 14 }}>
      Total pacientes: <strong>{total}</strong>
    </Typography>
  </Box>
  </Grid>

{/* Total previsiones */}
  <Grid
  size={{ xs: 12, sm: 6, md: 6 }}
  sx={{
    height: 600, // 🔥 obligatorio
    
    display: "flex",
    flexDirection: "column",
  }}
>
  <Box
  sx={{
    background:"#2a8d7490",
    display:'flex',
    alignItems:'center',
    justifyContent:'center',
    textAlign:'center',
    p:2
  }}
  >

  <Typography
    sx={{
     
      fontWeight: 600,
      fontFamily: "Poppins",
      textAlign: "center",
      color: "#585857",
    }}
  >
    Total previsiones
  </Typography>
  </Box>
  <Box>
  {hasDataPrevisiones ? (
    <ResponsiveContainer width="100%" height={450}>
      <BarChart
        data={chartDataPrevisiones}
        layout="vertical"
        margin={{ top: 20, right: 30, left: 0, bottom: 20 }}
      >
        <CartesianGrid strokeDasharray="3 3" />

        {/* Eje horizontal = monto */}
        <XAxis
          type="number"
          tick={{ fontSize: 11, fontFamily: 'Poppins', color: "#585857", fontWeight: 600 }}
        />

        {/* Eje vertical = previsiones */}
        <YAxis
          type="category"
          dataKey="name"
          tick={{ fontSize: 11, fontFamily: 'Poppins', color: "#585857", fontWeight: 600 }}
          width={110}
        />

        <Tooltip
          formatter={(value) =>
            new Intl.NumberFormat('es-CL', {
              style: 'currency',
              currency: 'CLP',
              maximumFractionDigits: 0,
            }).format(value)
          }
        />

        <Bar dataKey="monto" fill="#4c9470ff" name="Monto total" />
      </BarChart>
    </ResponsiveContainer>
  ) : (
    // 🔴 SIN INFORMACIÓN
    <Box
      sx={{
        height: 450,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        color: "#9e9e9e",
      }}
    >
      <BarChartOutlinedIcon sx={{ fontSize: 48, mb: 1 }} />
      <Typography
        sx={{
          fontFamily: "Poppins",
          fontSize: 13,
          fontWeight: 500,
          textAlign: "center",
        }}
      >
        Sin información disponible
      </Typography>
    </Box>
  )}
</Box>

  </Grid>
{/* Total pacientes por profesional */}
<Grid
  size={{ xs: 12, sm: 6, md: 6 }}
  sx={{
    height: 600, // 🔥 obligatorio
    
    display: "flex",
    flexDirection: "column",
  }}
>
  <Box
  sx={{
    background:"#2a8d7490",
    display:'flex',
    alignItems:'center',
    justifyContent:'center',
    textAlign:'center',
    p:2
  }}
  >

  <Typography
    sx={{
     
      fontWeight: 600,
      fontFamily: "Poppins",
      textAlign: "center",
      color: "#585857",
    }}
  >
    Total pacientes por profesional 
  </Typography>
  </Box>
 <Box sx={{ borderLeft: '1px solid #4c9470ff' }}>
  {hasDataKines ? (
    <ResponsiveContainer width="100%" height={500}>
      <BarChart
        data={chartDataKines}
        margin={{ top: 20, right: 30, left: 20, bottom: 80 }}
      >
        <CartesianGrid strokeDasharray="3 3" />

        {/* Kines */}
        <XAxis
          dataKey="name"
          tick={{ fontSize: 11, fontFamily: 'Poppins', color: "#585857", fontWeight: 600 }}
          interval={0}
          angle={-30}
          textAnchor="end"
        />

        <YAxis
          allowDecimals={false}
          tick={{ fontSize: 11, fontFamily: 'Poppins', color: "#585857", fontWeight: 600 }}
        />

        <Tooltip />

        {/* Barras por estado */}
        <Bar dataKey="ingreso" fill="#61d476ff" name="Ingreso" />
        <Bar dataKey="reingreso" fill="#0e7750ff" name="Reingreso" />
        <Bar dataKey="terapia" fill="#4f9aaeff" name="En terapia" />

      </BarChart>
    </ResponsiveContainer>
  ) : (
    // 🔴 SIN INFORMACIÓN
    <Box
      sx={{
        height: 500,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        color: "#9e9e9e",
      }}
    >
      <BarChartOutlinedIcon sx={{ fontSize: 48, mb: 1 }} />
      <Typography
        sx={{
          fontFamily: "Poppins",
          fontSize: 13,
          fontWeight: 500,
          textAlign: "center",
        }}
      >
        Sin información disponible
      </Typography>
    </Box>
  )}
</Box>

  </Grid>
  {/*   Pagos por cantidad de sesiones: ingresos & reingresos */}
 <Grid
  size={{ xs: 12, sm: 6 }}
  sx={{
    height: 600, // 🔥 obligatorio
    
    display: "flex",
    flexDirection: "column",
  }}
>
  <Box
  sx={{
    background:"#2a8d7490",
    display:'flex',
    alignItems:'center',
    justifyContent:'center',
    textAlign:'center',
    p:2
  }}
  >

  <Typography
    sx={{
     
      fontWeight: 600,
      fontFamily: "Poppins",
      textAlign: "center",
      color: "#585857",
    }}
  >
    Pagos por cantidad de sesiones: ingresos & reingresos
  </Typography>
  </Box>
   <Box sx={{ flex: 1, p: 2 }}>
  {hasDataSesiones ? (
    <ResponsiveContainer width="100%" height="100%">
      <LineChart data={chartDatasesionesingresosreingreso}>
        <CartesianGrid strokeDasharray="3 3" />

        <XAxis
          dataKey="sesiones"
          tick={{ fontSize: 11, fontFamily: 'Poppins', color: "#585857", fontWeight: 600 }}
        />

        <YAxis
          allowDecimals={false}
          tick={{ fontSize: 11, fontFamily: 'Poppins', color: "#585857", fontWeight: 600 }}
          label={{
            value: "N° Pacientes",
            angle: -90,
            position: "insideLeft",
            style: { fontFamily: "Poppins", fontSize: 12 },
          }}
        />

        <Tooltip
          formatter={(value) => [`${value} pacientes`, "Cantidad"]}
        />

        <Line
          type="monotone"
          dataKey="cantidad"
          stroke="#f2b705"
          strokeWidth={3}
          dot={{ r: 4 }}
          activeDot={{ r: 6 }}
        />
      </LineChart>
    </ResponsiveContainer>
  ) : (
    // 🔴 SIN INFORMACIÓN
    <Box
      sx={{
        height: "100%",
        minHeight: 280,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        color: "#9e9e9e",
      }}
    >
      <BarChartOutlinedIcon sx={{ fontSize: 48, mb: 1 }} />
      <Typography
        sx={{
          fontFamily: "Poppins",
          fontSize: 13,
          fontWeight: 500,
          textAlign: "center",
        }}
      >
        Sin información disponible
      </Typography>
    </Box>
  )}
</Box>

   
</Grid>
<Grid 
 size={{ xs: 12, sm: 6 }} 
sx={{
    height: 600, // 🔥 obligatorio
    
    display: "flex",
    flexDirection: "column",
  }}>
    <Box
  sx={{
    background:"#2a8d7490",
    display:'flex',
    alignItems:'center',
    justifyContent:'center',
    textAlign:'center',
    p:2
  }}
  >

  <Typography
    sx={{
     
      fontWeight: 600,
      fontFamily: "Poppins",
      textAlign: "center",
      color: "#585857",
    }}
  >
    Pagos por cantidad de sesiones: en terapia
  </Typography>
  </Box>
  <Box sx={{ flex: 1, p: 2 }}>
  {hasDataSesionesTerapia ? (
    <ResponsiveContainer width="100%" height="100%">
      <LineChart data={chartDatasesionesTerapia}>
        <CartesianGrid strokeDasharray="3 3" />

        <XAxis
          dataKey="sesiones"
          tick={{
            fontSize: 11,
            fontFamily: "Poppins",
            color: "#585857",
            fontWeight: 600,
          }}
        />

        <YAxis
          allowDecimals={false}
          tick={{
            fontSize: 11,
            fontFamily: "Poppins",
            color: "#585857",
            fontWeight: 600,
          }}
          label={{
            value: "N° Pacientes",
            angle: -90,
            position: "insideLeft",
            style: { fontFamily: "Poppins", fontSize: 12 },
          }}
        />

        <Tooltip
          formatter={(value) => [`${value} pacientes`, "Cantidad"]}
        />

        <Line
          type="monotone"
          dataKey="cantidad"
          stroke="#f2b705"
          strokeWidth={3}
          dot={{ r: 4 }}
          activeDot={{ r: 6 }}
        />
      </LineChart>
    </ResponsiveContainer>
  ) : (
    // 🔴 SIN INFORMACIÓN
    <Box
      sx={{
        height: "100%",
        minHeight: 280,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        color: "#9e9e9e",
      }}
    >
      <BarChartOutlinedIcon sx={{ fontSize: 48, mb: 1 }} />
      <Typography
        sx={{
          fontFamily: "Poppins",
          fontSize: 13,
          fontWeight: 500,
          textAlign: "center",
        }}
      >
        Sin información disponible
      </Typography>
    </Box>
  )}
</Box>

</Grid>
  <Grid
  size={{ xs: 12, sm: 6 }}
  sx={{
    height: 600, // 🔥 obligatorio
    
    display: "flex",
    flexDirection: "column",
  }}
>
  <Box
  sx={{
    background:"#2a8d7490",
    display:'flex',
    alignItems:'center',
    justifyContent:'center',
    textAlign:'center',
    p:2
  }}
  >

  <Typography
    sx={{
     
      fontWeight: 600,
      fontFamily: "Poppins",
      textAlign: "center",
      color: "#585857",
    }}
  >
   Pendientes de pago previsiones
  </Typography>
  </Box>
 <Box sx={{ borderLeft: '1px solid #4c9470ff', height: 450 }}>
  {hasDataNoPagados ? (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart
        data={chartDataNoPagados}
        margin={{ top: 20, right: 30, left: 20, bottom: 90 }}
      >
        <CartesianGrid strokeDasharray="3 3" />

        {/* Previsiones */}
        <XAxis
          dataKey="name"
          tick={{
            fontSize: 11,
            fontFamily: 'Poppins',
            color: "#585857",
            fontWeight: 600
          }}
          interval={0}
          angle={-30}
          textAnchor="end"
        />

        {/* Cantidad */}
        <YAxis
          allowDecimals={false}
          tick={{
            fontSize: 11,
            fontFamily: 'Poppins',
            color: "#585857",
            fontWeight: 600
          }}
        />

        <Tooltip formatter={(value) => `${value} pacientes`} />

        {/* Estados NO pagados (apilados) */}
        <Bar dataKey="ingreso" stackId="a" fill="#944c4cff" name="Ingreso" />
        <Bar dataKey="reingreso" stackId="a" fill="#bf946fff" name="Reingreso" />
        <Bar dataKey="terapia" stackId="a" fill="#8c3e3eff" name="En terapia" />
        <Bar dataKey="pendiente" stackId="a" fill="#9d6f52ff" name="Pendiente" />
      </BarChart>
    </ResponsiveContainer>
  ) : (
    // 🔴 SIN INFORMACIÓN
    <Box
      sx={{
        height: "100%",
        minHeight: 280,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        color: "#9e9e9e",
      }}
    >
      <BarChartOutlinedIcon sx={{ fontSize: 48, mb: 1 }} />
      <Typography
        sx={{
          fontFamily: "Poppins",
          fontSize: 13,
          fontWeight: 500,
          textAlign: "center",
        }}
      >
        Sin información disponible
      </Typography>
    </Box>
  )}
</Box>




  </Grid>
   <Grid size={{xs:12,sm:6}}>
               <Box
  sx={{
    background:"#2a8d7490",
    display:'flex',
    alignItems:'center',
    justifyContent:'center',
    textAlign:'center',
    p:2
  }}
  >

  <Typography
    sx={{
     
      fontWeight: 600,
      fontFamily: "Poppins",
      textAlign: "center",
      color: "#585857",
    }}
  >
   Total de deudores semana
  </Typography>
  </Box>
   

   <Box sx={{ width: "100%", height: 300 }}>
  {hasDataDeudoresSemanal ? (
    <ResponsiveContainer>
      <PieChart>
        <Pie
          data={dataDeudoresSemanal}
          dataKey="value"
          nameKey="name"
          innerRadius={55}
          outerRadius={90}
          paddingAngle={3}
        >
          {dataDeudoresSemanal.map((_, index) => (
            <Cell
              key={index}
              fill={COLORS[index % COLORS.length]}
            />
          ))}
        </Pie>

        <Tooltip
          formatter={(value, name) => [`${value} deudores`, name]}
        />
        <Legend verticalAlign="bottom" />
      </PieChart>
    </ResponsiveContainer>
  ) : (
    // 🔴 SIN INFORMACIÓN
    <Box
      sx={{
        height: "100%",
        minHeight: 280,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        color: "#9e9e9e",
      }}
    >
      <BarChartOutlinedIcon sx={{ fontSize: 48, mb: 1 }} />
      <Typography
        sx={{
          fontFamily: "Poppins",
          fontSize: 13,
          fontWeight: 500,
          textAlign: "center",
        }}
      >
        Sin información disponible
      </Typography>
    </Box>
  )}
</Box>

  </Grid>

            </Grid>
      
  


               
            </Paper>
          </Box>
        );
      })}
    </>
  );
};
